import React from "react";
import { API_BASE } from '../lib/endpoints.js';

// 2026-09-01 (фаза3 П3, свод P4/cursor H3) — `embedded`: рендер внутри SessionExpiredDialog
// (своя карточка уже есть — полноэкранный тёмный фон поверх был бы «модалка в модалке»).
// Дефолт (embedded=false) не тронут — та же полноэкранная обёртка, что и раньше.
export default function TwoFAScreen({ twoFAToken, onSuccess, onBack, embedded = false }) {
  const [code, setCode] = React.useState('');
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  // 2026-09-01 (фикс-раунд ФР1, cursor HIGH×2 = жюри A MEDIUM) — свод П3/P6 требовал guard
  // от двойного submit «и в форме, и в 2FA»; здесь его не было — только useState(loading),
  // а два независимых пути к submit() (onKeyDown Enter + onClick) читают ОДНО И ТО ЖЕ
  // значение loading из замыкания рендера, пока React не закоммитит первый setLoading(true)
  // — тот же TOCTOU-класс, что busyRef в ReloginForm закрывает для формы пароля (см. тот
  // компонент). loadingRef — синхронный гейт (поднимается ДО await, снимается в finally).
  // genRef — поколение запроса: инвалидируется на onBack И на unmount, ответ (включая
  // onSuccess!) применяется только при актуальном поколении — "Back to login" во время
  // полёта не должен позволить позднему ответу дозвониться до onSuccess/onRelogin.
  const loadingRef = React.useRef(false);
  const genRef = React.useRef(0);
  React.useEffect(() => () => { genRef.current += 1; }, []);

  const handleBack = () => {
    genRef.current += 1; // инвалидировать текущий in-flight запрос, если он есть
    if (onBack) onBack();
  };

  const submit = async () => {
    if (loadingRef.current) return;
    if (code.length !== 6) { setError('Enter the 6-digit code'); return; }
    loadingRef.current = true;
    setLoading(true); setError('');
    const myGen = ++genRef.current;
    try {
      const res = await fetch(API_BASE + '/auth/2fa', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        // 2026-08-07: обязательно — именно этот ответ ставит метку доверенного устройства
        // (Set-Cookie blitz_device). Без credentials браузер её отбросит в локальной разработке.
        credentials: 'include',
        body: JSON.stringify({ twoFAToken, code }), signal: AbortSignal.timeout(10000)
      });
      const j = await res.json();
      if (myGen !== genRef.current) return; // Back нажали или компонент ушёл, пока ответ летел
      if (j.ok) { onSuccess(j); return; }
      setError(j.error || 'Invalid code');
    } catch(e) {
      if (myGen !== genRef.current) return;
      setError('Network error');
    } finally {
      if (myGen === genRef.current) { loadingRef.current = false; setLoading(false); }
    }
  };
  const outerStyle = embedded
    ? {display:'flex',alignItems:'center',justifyContent:'center'}
    : {minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#0f172a'};
  return (
    <div style={outerStyle}>
      <div style={{background:'#1e293b',borderRadius:16,padding:'40px 36px',width:340,boxShadow:'0 20px 60px rgba(0,0,0,0.5)',textAlign:'center'}}>
        <div style={{fontSize:48,marginBottom:12}}>&#128272;</div>
        <h2 style={{color:'#f1f5f9',margin:'0 0 8px',fontSize:22,fontWeight:700}}>2FA Verification</h2>
        <p style={{color:'#94a3b8',margin:'0 0 24px',fontSize:14}}>Check <strong style={{color:'#38bdf8'}}>@blitz_finance_bot</strong> on Telegram for your 6-digit code</p>
        <input type="text" inputMode="numeric" maxLength={6} placeholder="000000"
          value={code} onChange={e=>setCode(e.target.value.replace(/[^0-9]/g,''))}
          onKeyDown={e=>e.key==='Enter'&&submit()}
          style={{width:'100%',padding:'14px',fontSize:28,textAlign:'center',letterSpacing:10,
            border:'2px solid '+(error?'#ef4444':code.length===6?'#3b82f6':'#334155'),
            borderRadius:10,background:'#0f172a',color:'#f1f5f9',outline:'none',
            boxSizing:'border-box',marginBottom:8,transition:'border-color 0.2s'}} autoFocus />
        {error && <div style={{color:'#ef4444',fontSize:13,marginBottom:12,padding:'8px',background:'rgba(239,68,68,0.1)',borderRadius:6}}>{error}</div>}
        <button onClick={submit} disabled={loading||code.length!==6}
          style={{width:'100%',padding:'13px',
            background:code.length===6?'linear-gradient(135deg,#0EA5E9,#38BDF8)':'#1e3a5f',
            color:'#fff',border:'none',borderRadius:10,fontSize:16,fontWeight:600,
            cursor:code.length===6?'pointer':'default',marginBottom:12,
            boxShadow:code.length===6?'0 4px 15px rgba(14,165,233,0.3)':'none'}}>
          {loading?'Verifying...':'Verify Code'}
        </button>
        <button onClick={handleBack} style={{background:'none',border:'none',color:'#64748b',fontSize:13,cursor:'pointer'}}>Back to login</button>
        <p style={{color:'#475569',fontSize:11,marginTop:12,marginBottom:0}}>Code expires in 5 minutes</p>
      </div>
    </div>
  );
}
